import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, IconDefinition, faTrash, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { Address } from "../../services/customer.address.service";
import { tokenService } from "../../services/token.service";
import { getDniLabel } from "../../services/utils.service";
import "../../styles/common/AddressSelectionCard.css";


interface AddressSelectionCardProps {
    address: Address;
    isSelected: boolean;
    onClick: () => void;
    icon: IconDefinition;
    onDelete?: (e: React.MouseEvent) => void;
    onEdit?: (e: React.MouseEvent) => void;
}

const AddressSelectionCard: React.FC<AddressSelectionCardProps> = ({
    address,
    isSelected,
    onClick,
    icon,
    onDelete,
    onEdit
}) => {
    return (
        <div
            className={`address-card-selectable ${isSelected ? 'selected' : ''}`}
            onClick={onClick}
        >
            <div className="card-icon"><FontAwesomeIcon icon={icon} /></div>
            <div className="card-info">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <strong>{address.nickname}</strong>
                    {address.isDefault && (
                        <span style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            backgroundColor: '#fef9c3',
                            color: '#854d0e',
                            fontSize: '10px',
                            fontWeight: 700,
                            padding: '2px 8px',
                            borderRadius: '9999px',
                            border: '1px solid #fde047',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}>Predeterminada</span>
                    )}
                    {address.addressSubjet?.isThirdPerson && (
                        <span className="third-person-badge" style={{ marginTop: 0 }}>Tercero</span>
                    )}
                </div>
                {address.addressSubjet?.firstName && (
                    <small style={{ display: 'block', marginTop: '4px', fontWeight: 600, color: '#334155' }}>
                        {address.addressSubjet.firstName} {address.addressSubjet.lastName}
                    </small>
                )}
                {address.addressSubjet?.dni && (
                    <small style={{ display: 'block', marginTop: '2px', color: '#64748b' }}>
                        Doc: {getDniLabel([], address.addressSubjet.kindOfDNI)} - {address.addressSubjet.dni}
                    </small>
                )}
                {(() => {
                    const phoneToShow = address.addressSubjet?.phoneNumber || tokenService.getCustomerDataToken()?.customerData?.PhoneNumber;
                    if (!phoneToShow) return null;
                    return (
                        <small style={{ display: 'block', marginTop: '2px', color: '#64748b' }}>
                            Tel: {phoneToShow}
                        </small>
                    );
                })()}
                {address.addressLine1 && <p style={{ marginTop: '4px' }}>{address.addressLine1}</p>}
                {(address.city || address.state || address.zipCode) && (
                    <small>
                        {address.city}
                        {address.city && address.state ? ", " : ""}
                        {address.state}
                        {address.zipCode ? ` ${address.zipCode}` : ""}
                    </small>
                )}
            </div>
            {onEdit && (
                <button
                    type="button"
                    className="card-action-btn edit"
                    onClick={(e) => {
                        e.stopPropagation();
                        onEdit(e);
                    }}
                    title="Editar dirección"
                >
                    <FontAwesomeIcon icon={faPencilAlt} />
                </button>
            )}
            {onDelete && (
                <button
                    type="button"
                    className="card-action-btn delete"
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete(e);
                    }}
                    title="Eliminar dirección"
                >
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            )}
            {isSelected && <div className="card-selected-badge"><FontAwesomeIcon icon={faCheck} /></div>}
        </div>
    );
};

export default AddressSelectionCard;
